import { render } from "./supplier_put.vue?vue&type=template&id=6b5075be"
import script from "./supplier_put.vue?vue&type=script&lang=js"
export * from "./supplier_put.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__